import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { useHoliday } from './context';
import { HolidayLayers } from './HolidayLayers';

/**
 * The app frame (Handoff section 3): `position: relative; isolation: isolate; overflow: hidden`, so the
 * z -1 particle layer paints above the frame background and under the page, with the engine's `bg` as
 * the frame background. `bg` is a light page texture, so it is applied in light mode only; in dark mode
 * the app keeps its own background.
 */
export function HolidayFrame(props: { sx: SxProps<Theme>; children: ReactNode }) {
  const { hol } = useHoliday();
  const light = useTheme().palette.mode === 'light';
  return (
    <Box
      sx={[
        { position: 'relative', isolation: 'isolate', overflow: 'hidden' },
        hol.show && light ? { background: hol.bg } : {},
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <HolidayLayers />
      {props.children}
    </Box>
  );
}
